import { NotificationTypeTypes } from '../../../types/account/notificationTypeTypes.ts';

export interface IReminderEvent {
    id: string,
    targetType: NotificationTypeTypes,
    targetId: number | string,
    title: string
}

export interface IReminderEventDto {
    id: string,
    target_type: NotificationTypeTypes,
    target_id: number | string,
    title: string
}

export function mapIReminderEventDtoToModel(dto: IReminderEventDto): IReminderEvent {
    return {
        id: dto.id,
        title: dto.title,
        targetId: dto.target_id,
        targetType: dto.target_type,
    };
}